import React from 'react';
import { Link } from 'react-router-dom';

function Card(props) {
    return (
        props.link === null ?
            (
                <Link to="/pagenotfound">

                    <div className="cardtext center" style={{ backgroundColor: "transparent", color: props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9", maxWidth: props.width, alignItems: "center" }}>
                        <div className="promo">
                            <img src={props.src} className="photo" alt="Project Pic" />
                            <h3 style={{ textDecoration: "underline" }}>{props.title}</h3>
                        </div>
                        <div className="text" style={{ color: props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9" }}>
                            <h4 style={{ textDecoration: "underline" }}>{props.title}</h4>
                            <p>{props.desc}</p>
                            <div className="card-footer d-flex justify-content-between" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>
                                {props.date}
                            </div>
                        </div>
                    </div>
                </Link>
            )
            :
            (
                <Link to={props.link} target='_blank' >
                    <div className="cardtext center" style={{ backgroundColor: "transparent", color: props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9", maxWidth: props.width, alignItems: "center" }}>
                        <div className="promo">
                            <img src={props.src} className="photo" alt="Project Pic" />
                            <h3 style={{ textDecoration: "underline" }}>{props.title}</h3>
                        </div>
                        <div className="text" style={{ color: props.color === "#2B7A78" ? "#2B7A78" : "#3AAFA9" }}>
                            <h4 style={{ textDecoration: "underline" }}>{props.title}</h4>
                            <p>{props.desc}</p>
                            <div className="card-footer d-flex justify-content-between" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>
                                {props.date}
                            </div>
                        </div>
                    </div>
                </Link>
            )
    );
}

export default Card;
